export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

/**
 * Active menu matching:
 * - exact path match, or child path (target + '/')
 * - /apps/tours does NOT stay active on /apps/tours/configurations|reservations|promotions
 */
export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  const target = getCurrentUrl(url)
  if (!current || !target) {
    return false
  }

  if (current === target) {
    return true
  }

  if (!current.startsWith(target + '/')) {
    return false
  }

  // Avoid highlighting "Tours" list when browsing tour sub-apps
  if (target === '/apps/tours') {
    const firstSeg = current.slice('/apps/tours/'.length).split('/')[0]
    if (['configurations', 'reservations', 'promotions'].includes(firstSeg)) {
      return false
    }
  }

  return true
}
